import { BOARD_WIDGET_TEMPLATES, type BoardTemplateId } from "@bezpart-board/shared";

type Props = {
  onPick: (templateId: BoardTemplateId) => void;
  onInsertTimer?: () => void;
  onInsertCalculator?: () => void;
  onInsertGraphUnits?: () => void;
  onInsertCode?: () => void;
  onInsertSql?: () => void;
  /** Опрос «кто как решил» — живёт поверх доски, не объектом сцены. */
  onInsertPoll?: () => void;
};

export function BoardWidgetsFlyout({
  onPick,
  onInsertTimer,
  onInsertCalculator,
  onInsertGraphUnits,
  onInsertCode,
  onInsertSql,
  onInsertPoll,
}: Props) {
  return (
    <div className="wb-widgets-flyout" role="listbox" aria-label="Виджеты">
      {onInsertPoll ? (
        <button
          type="button"
          role="option"
          className="wb-widgets-flyout__item"
          title="Быстрый вопрос классу: кто как решил"
          onClick={() => onInsertPoll()}
        >
          <span className="wb-widgets-flyout__title">Опрос</span>
          <span className="wb-widgets-flyout__text">
            Вопрос с вариантами: видно, кто что выбрал
          </span>
        </button>
      ) : null}
      {onInsertTimer ? (
        <button
          type="button"
          role="option"
          className="wb-widgets-flyout__item"
          title="Обратный отсчёт для заданий на уроке"
          onClick={() => onInsertTimer()}
        >
          <span className="wb-widgets-flyout__title">Таймер</span>
          <span className="wb-widgets-flyout__desc">Обратный отсчёт 1–10 минут</span>
        </button>
      ) : null}
      {onInsertCalculator ? (
        <button
          type="button"
          role="option"
          className="wb-widgets-flyout__item"
          title="Калькулятор на доске"
          onClick={() => onInsertCalculator()}
        >
          <span className="wb-widgets-flyout__title">Калькулятор</span>
          <span className="wb-widgets-flyout__desc">Научный счёт</span>
        </button>
      ) : null}
      {onInsertGraphUnits ? (
        <button
          type="button"
          role="option"
          className="wb-widgets-flyout__item"
          title="График функций как на ОГЭ и ЕГЭ"
          onClick={() => onInsertGraphUnits()}
        >
          <span className="wb-widgets-flyout__title">Графики</span>
          <span className="wb-widgets-flyout__desc">Несколько функций, ОДЗ, точки</span>
        </button>
      ) : null}
      {onInsertCode ? (
        <button
          type="button"
          role="option"
          className="wb-widgets-flyout__item"
          title="Python, JavaScript или HTML/CSS прямо на доске"
          onClick={() => onInsertCode()}
        >
          <span className="wb-widgets-flyout__title">Код</span>
          <span className="wb-widgets-flyout__desc">Python · JS · HTML/CSS</span>
        </button>
      ) : null}
      {onInsertSql ? (
        <button
          type="button"
          role="option"
          className="wb-widgets-flyout__item"
          title="Базы данных и SQL: задания с проверкой прямо на доске"
          onClick={() => onInsertSql()}
        >
          <span className="wb-widgets-flyout__title">SQL</span>
          <span className="wb-widgets-flyout__desc">Базы данных · задания с проверкой</span>
        </button>
      ) : null}
      {BOARD_WIDGET_TEMPLATES.map((tpl) => (
        <button
          key={tpl.id}
          type="button"
          role="option"
          className="wb-widgets-flyout__item"
          title={tpl.description}
          onClick={() => onPick(tpl.id)}
        >
          <span className="wb-widgets-flyout__title">{tpl.title}</span>
          <span className="wb-widgets-flyout__desc">{tpl.description}</span>
        </button>
      ))}
    </div>
  );
}
